import { useCallback } from "react"
import { useProdutoApi } from "../../infra/produto"
import { useAppDispatch, useAppSelector } from "../../presentation/hooks/store-hooks"
import { IModuleInfo, setCurrentUserModulesState } from "../../application/states/user"
import { setProdutosTipoConsumoState } from "../../application/states/produto"
import { useUIService } from "../ui"

export const useProdutoService = () => {
    // dispatch
    const dispatch = useAppDispatch()
    // State
    const { currentUser } = useAppSelector((state) => state.user)
    // Infra
    const { getProdutosByIdUsuarioApi } = useProdutoApi()
    const { getAllProdutosAndTipoConsumosApi } = useProdutoApi()
    // Service
    const { setAlert, setLoading } = useUIService()


    // Actions
    const getProdutosByIdUsuarioAndSetModules = useCallback(async () => {
        dispatch(setCurrentUserModulesState([

        ]))
        if (currentUser) {
            const loadingId = Math.random().toString()
            try {
                setLoading({
                    id: loadingId,
                    loading: true,
                    message: 'Buscando módulos do usuário...'
                })
                const getProdutosByIdUsuario = await getProdutosByIdUsuarioApi({
                    IdUsuario: currentUser.IdUsuario
                })

                const moduleInfo: IModuleInfo[] = getProdutosByIdUsuario.map((produto) => {
                    return {
                        IdProduto: produto.IdProduto,
                        Nome: produto.Descricao
                    }
                })

                dispatch(setCurrentUserModulesState(moduleInfo))
            } catch (error: any) {
                setAlert({
                    message: error.response.data.error,
                    type: 'error'
                })
            } finally {
                setLoading({
                    id: loadingId,
                    loading: false
                })
            }
        }
    }, [currentUser, dispatch, getProdutosByIdUsuarioApi, setAlert, setLoading])


    const setAllProdutosAndTipoConsumo = useCallback(async () => {
        const loadingId = Math.random().toString()
        if (currentUser) {
            try {
                setLoading({
                    id: loadingId,
                    loading: true,
                    message: 'Buscando produtos...'
                })

                const getAllProdutosAndTipoConsumo = await getAllProdutosAndTipoConsumosApi({})

                // verificar para que serve o dispatch
                dispatch(setProdutosTipoConsumoState(getAllProdutosAndTipoConsumo))
            }

            catch (error: any) {
                setAlert({
                    message: error.response.data.error,
                    type: 'error'
                })
            }

            finally {
                setLoading({
                    id: loadingId,
                    loading: false
                })
            }
        }
    }, [currentUser, dispatch, getAllProdutosAndTipoConsumosApi, setAlert, setLoading])

    return {
        getProdutosByIdUsuarioAndSetModules,
        setAllProdutosAndTipoConsumo,        
    }
}